import { LayoutServiceData } from "@sitecore-jss/sitecore-jss-nextjs";

export const shouldShowHeroHeader = (
  layoutData: LayoutServiceData,
): boolean => {
  const templates = [
    "customer care page",
    "legal page",
    "hub page",
    "editorial page",
  ];
  const { route } = layoutData.sitecore || {};
  const templateName = route?.templateName?.toLocaleLowerCase();
  return templates.some((tempName) => tempName === templateName);
};
